import { Flex } from '@chakra-ui/react';
import { BudgetAllocationDrawer } from 'Deer/intent/Compensation/components/BudgetAllocationDrawer';
import { CreateGuidelineDrawer } from 'Deer/intent/Compensation/components/CreateGuidelineDrawer';
import { WorkflowStakeholdersDrawer } from 'Deer/intent/Compensation/components/WorkflowStakeholdersDrawer';
import { useParams } from 'react-router-dom';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { CompensationPresets } from './CompensationPresets';
import { CompensationBudgetSection } from './components/CompensationBudgetSection';
import { CompensationCreationFooter } from './components/CompensationCreationFooter';
import { CompensationCreationHeader } from './components/CompensationCreationHeader';
import { CompensationCycleDetailsSection } from './components/CompensationCycleDetailsSection';
import { CompensationDeliverableSection } from './components/CompensationDeliverableSection';
import { CompensationTimelineSection } from './components/CompensationTimelineSection';

export const CompensationCycleCreation = () => {
  const { compensationCycleId } = useParams<{ compensationCycleId: string }>();
  const isPresets = compensationCycleId === 'presets';

  if (isPresets) {
    return <CompensationPresets />;
  }

  return (
    <Flex flexDirection="column" w="100%" h="100%" maxH="calc(100vh - 20px)" gap="12px">
      <CompensationCreationHeader title="Create a new compensation cycle" />
      <PaperWithShadow display="flex" flexDir="column" py={0} flex={1} overflow="auto" transition="margin .3s ease">
        <Flex flex={1} p={4} pb={3} overflow="auto" borderRadius="8px" bg="white" flexDir="column">
          <Flex flex={1} p={2} borderRadius="8px" bg="surface.F5F7F9" flexDir="column" gap={2}>
            <CompensationCycleDetailsSection />
            <CompensationBudgetSection />
            <CompensationTimelineSection />
            <CompensationDeliverableSection />
          </Flex>
        </Flex>
        <CompensationCreationFooter />
        {/* Drawers */}
        <WorkflowStakeholdersDrawer />
        <BudgetAllocationDrawer />
        <CreateGuidelineDrawer />
      </PaperWithShadow>
    </Flex>
  );
};
